import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import { getUserLifestyle, type UserLifestyle } from '@/features/survey/api/surveys'

/** BE-141 — `GET /user/lifestyle`; off (key null) for a guest. */
export const useUserLifestyleQuery = (enabled: MaybeRef<boolean> = true) => {
  return createQuery<UserLifestyle>({
    key: computed(() => (unref(enabled) ? ['user-lifestyle'] : null)),
    fetcher: async () => {
      const response = await getUserLifestyle()
      return response.data
    },
    staleTime: 5 * 60 * 1000,
  })
}
